import findResult, {
  assignIfExists, findMatch, firstSelected,
} from '@/utils/resultsHelper';
import { responseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import {
  activeValidateDataResults,
  datasetConversionState,
  datasetValidationState,
  dictionaryConversionState,
  dictionaryValidationState, findDatasetData, findDatasetDataDictionary,
  upsertConversionDictionary,
  upsertValidationDictionary,
} from './state';
import actions from '../constants';

const convertDictionaryData = withDraft((draft, action) => {
  const item = findDatasetData(draft, action);

  if (item) {
    upsertConversionDictionary(item, action.dictionaryCode);
    const conversionDictionary = findMatch(item.dictionaries, action.dictionaryCode);
    assignIfExists(conversionDictionary, {
      saveStatus: states.PENDING,
      saveErrors: [],
    });
  } else {
    draft.dataManagement[action.category].results.push({
      ...datasetConversionState(),
      code: action.code,
      dictionaries: [{
        ...dictionaryConversionState(),
        code: action.dictionaryCode,
        saveStatus: states.PENDING,
      }],
    });
  }
});

const convertDictionaryDataSuccess = withDraft((draft, action) => {
  const { dictionary } = findDatasetDataDictionary(draft, action);
  assignIfExists(dictionary, {
    saveStatus: states.SUCCESS,
    saveErrors: [],
  });
});

const convertDictionaryDataError = withDraft((draft, action) => {
  const { dictionary } = findDatasetDataDictionary(draft, action);
  dictionary.saveStatus = states.ERROR;
  dictionary.saveErrors = [responseError(action)];
});

const validateDictionaryData = withDraft((draft, action) => {
  const item = findDatasetData(draft, action);

  if (item) {
    upsertValidationDictionary(item, action.dictionaryCode);
    const validationDictionary = findMatch(item.dictionaries, action.dictionaryCode);
    assignIfExists(validationDictionary, {
      readStatus: states.PENDING,
      readErrors: [],
    });
  } else {
    draft.dataManagement[action.category].results.push({
      ...datasetValidationState(),
      code: action.code,
      dictionaries: [{
        ...dictionaryValidationState(),
        code: action.dictionaryCode,
        readStatus: states.PENDING,
      }],
    });
  }
});

const validateDictionaryDataSuccess = withDraft((draft, action) => {
  const { dictionary } = findDatasetDataDictionary(draft, action);
  assignIfExists(dictionary, {
    readStatus: states.SUCCESS,
    readErrors: [],
    name: action.result.name,
    status: action.result.status,
    valid: action.result.valid,
    errors: action.result.errors || [],
    selected: true,
  });
});

const validateDictionaryDataError = withDraft((draft, action) => {
  const { dictionary } = findDatasetDataDictionary(draft, action);
  dictionary.readStatus = states.ERROR;
  dictionary.readErrors = [responseError(action)];
});

const showValidateDictionaryDataStatus = withDraft((draft, action) => {
  const item = findDatasetData(draft, action);

  if (item) {
    item.dictionaries = item.dictionaries.map((d) => ({ ...d, selected: false }));
    upsertValidationDictionary(item, action.dictionaryCode);
    const validationDictionary = findMatch(item.dictionaries, action.dictionaryCode);
    assignIfExists(validationDictionary, {
      name: action.dictionaryName,
      selected: true,
    });
  } else {
    draft.dataManagement[action.category].results.push({
      ...datasetValidationState(),
      code: action.code,
      dictionaries: [{
        ...dictionaryValidationState(),
        code: action.dictionaryCode,
        name: action.dictionaryName,
        selected: true,
      }],
    });
  }
  const validationItem = findResult(draft.dataManagement, action.category, action.code);
  const selectedDictionary = firstSelected(validationItem.dictionaries);

  draft.validateDataResultsDialog.open = !!action.inDialog;
  draft.validateDataResultsDialog.category = action.category;
  draft.validateDataResultsDialog.code = action.code;
  draft.validateDataResultsDialog.dictionaryCode = selectedDictionary.code;
  draft.validateDataResultsDialog.dictionaryName = selectedDictionary.name;
  draft.validateDataResultsDialog.valid = selectedDictionary.valid;
  draft.validateDataResultsDialog.errors = selectedDictionary.errors;
});

const hideValidateDictionaryDataStatus = withDraft((draft, action) => {
  const { dictionary } = findDatasetDataDictionary(draft, action);
  dictionary.selected = false;
  draft.validateDataResultsDialog = activeValidateDataResults();
});

export default {
  [actions.CONVERT_DICTIONARY_DATA]: convertDictionaryData,
  [actions.CONVERT_DICTIONARY_DATA_SUCCESS]: convertDictionaryDataSuccess,
  [actions.CONVERT_DICTIONARY_DATA_ERROR]: convertDictionaryDataError,
  [actions.VALIDATE_DICTIONARY_DATA]: validateDictionaryData,
  [actions.VALIDATE_DICTIONARY_DATA_SUCCESS]: validateDictionaryDataSuccess,
  [actions.VALIDATE_DICTIONARY_DATA_ERROR]: validateDictionaryDataError,
  [actions.SHOW_VALIDATE_DICTIONARY_DATA_STATUS]: showValidateDictionaryDataStatus,
  [actions.HIDE_VALIDATE_DICTIONARY_DATA_STATUS]: hideValidateDictionaryDataStatus,
};
